import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-import",
  "use": "icon-import-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-import\"><g stroke=\"#222\" stroke-width=\"1.5\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M20 10.152v7.966c0 .487-.448.882-1 .882H6c-.552 0-1-.395-1-.882V4.882C5 4.395 5.448 4 6 4h7.92\" stroke-linejoin=\"round\" /><path d=\"M15.5 13.5h-5v-5M10.5 13.5l9-9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol